import * as React from 'react';
import { MapContext } from '../Map';
import useBindEvents from '../../hooks/useBindEvents';
import { Events } from '../../types';

const { useContext, useEffect, useState, useRef } = React;

export interface PolylineProps {
  polylineOptions: {
    path: any; // AMap.LocationValue[] | AMap.LocationValue[][] | undefined;
    [option: string]: any;
  };
  events?: Events;
  hoverLabel?: AMap.Marker.Label;
}

function Polyline(props: PolylineProps) {
  const { polylineOptions, events, hoverLabel} = props;
  const map = useContext(MapContext);
  const [polyline, setPolyline]: [any, any] = useState(null);
  const [newMarker, setNewMarker]: [any, any] = useState(null);
  const [target, setTarget]: [any, any] = useState(null);
  useBindEvents(polyline, events);

  useEffect(() => {
    if (!map) {
      return;
    }
    if (polyline) {
      ((map as unknown) as AMap.Map).remove([polyline]);
    }

    const { path } = polylineOptions;

    // 判断是否有正确点坐标
    if (path.length < 2 || !path.every((item: number[]) => item[0] && item[1])) {
      return;
    }

    // 竟然还有深浅拷贝的问题
    const newPolyline = new AMap.Polyline(JSON.parse(JSON.stringify(props.polylineOptions)));

    if (props.hoverLabel) {
      setNewMarker(() => new AMap.Marker({content:"<div></div>"}));
      // 设置hover显示Polyline名称
      newPolyline.on('mouseover', (e: any) => {
          //组件插入到Map实例dom中
        setTarget(e);
      });
      newPolyline.on('mouseout', (e: any) => {
          //删除组件
        setTarget(null);
      });
    }

    ((map as unknown) as AMap.Map).add(newPolyline);
    (map as unknown as AMap.Map).setFitView();

    setPolyline(newPolyline);

    return () => {
      if (newPolyline) {
        ((map as unknown) as AMap.Map).remove([newPolyline]);
      }
      if (newMarker) {
        ((map as unknown) as AMap.Map).remove(newMarker);
      }
    };
  }, [map, polylineOptions]);

  useEffect(()=>{
    if (map && newMarker){
      if (target) {
        const { lng, lat } = target.lnglat;
        newMarker.setPosition(new AMap.LngLat(lng, lat));
        newMarker.setLabel({ ...hoverLabel});
        ((map as unknown) as AMap.Map).add(newMarker);
      } 
    }
    return () => {
      if(map&& newMarker){
        ((map as unknown) as AMap.Map).remove(newMarker);
      }
    }

  }, [target]);

  return null;
}

export default Polyline;
